import React, { useState, useEffect } from "react";
import { Card, CardBody, Col, Row, Input, Label, Modal, ModalBody} from "reactstrap";
import moment from "moment";
//import { Button, Accordion, } from "react-bootstrap";

//Import Images
import { AppConfiguration } from "read-appsettings-json";
import { GetRequest, PostRequest } from '../../noser-dataaccess'
import axios from 'axios'
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import { Link, useNavigate } from "react-router-dom";
import paginationFactory from 'react-bootstrap-table2-paginator';
// import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import dateFormat from 'dateformat';
import '../../noser-hris.css';

const EmployerJobPostingList = () => {

    const [listOfJobs, setDlistOfJobs] = useState([]);
    const [wdata,setwdata] = useState([]);
    const [mainGrid, setmainGrid] = useState([
       /*  {
            "id":"1",
            "postingId":"1",
            "name":"tasyo",
            "title":"tambay",
            "expectedSalary":"100,000",
            "city":"makati",
            "resume":"",
            "ScheduleInterview":"",
            "action2":"",
        },
        {
            "id":"phr-1-2-3",
            "postingId":"phr-1-2-3",
            "name":"dio",
            "title":"food tester",
            "expectedSalary":"40,000",
            "city":"taguig",
            "resume":"",
            "ScheduleInterview":"",
        } */
    ]);
    const [companyProfiles, setcompanyProfiles] = useState([]);
    const [jobPosted, setjobPosted] = useState([]);
    const [search, setsearch] = useState("");
    const [statusData, setstatusData] = useState([
       
        {
           "id":"1",
           "label":"New",
           "value":"NW"
        },
        {
            "id":"2",
            "label":"pre-screen",
            "value":"PS"
        },
        {
            "id":"3",
            "label":"keep warm",
            "value":"KW"
        },
        {
            "id":"4",
            "label":"shorlisted",
            "value":"SL"
        },
        {
            "id":"5",
            "label":"Unmatched",
            "value":"Unmatched"
        },
    ]);
    const [jobRef, setjobRef] = useState("");
    const [pstingDateFilter, setpstingDateFilter] = useState("");
    const [jobPostStatus, setjobPostStatus] = useState("");
    const [jobtitlefilter, setjobtitlefilter] = useState("");
    const [endDateFilter, setendDateFilter] = useState("");
    const [applicantLists, setApplicantList] = useState([]);

const [modalNotif, setModalValidationNotif] = useState(false);
const openModalNotif = () => setModalValidationNotif(true);


    const rowClasses = 'custom-row-class-success';


    useEffect(() => {
       // OnLoadScreen()
         GetCompanyProfile()
        GetApplicants() // error 500 ???
        let toEdit = JSON.parse(sessionStorage.getItem("jobPostedEdit"))
       /*  if(JSON.parse(sessionStorage.getItem("jobPostedEdit")) !== null){
            GetCandidatesFilterd(toEdit)
        }else{
            GetCandidates()
        } */
        sessionStorage.removeItem("validate")
        sessionStorage.removeItem("JobPostingList")
    },[]);

    const helperBuildCriteria=()=>{

        let _transacDate = ""//moment(newtransacDate).format('MM/DD/YYYY');

        let _filterData = ""
        let _jobRefNo = ""
        let _jobtitle = ""
        let _postingDate = ""
        let _EndDate = ""
        let _status = "" 

        //let transactionDate = (this.state.transactionDate) ? moment(this.state.transactionDate).format('MM/DD/YYYY') : ""
        
        if (jobRef != "" || jobRef !== "") {
            _jobRefNo = "postingId" + ":" + jobRef + ","
        }
        if (pstingDateFilter != "" || pstingDateFilter !== "") {
            _postingDate = "postingId" + ":" + pstingDateFilter + ","
        }
        if (endDateFilter != "" || endDateFilter !== "") {
            _EndDate = "endDate" + ":" + endDateFilter + ","
        }
        if (jobtitlefilter != "" || jobtitlefilter !== "") {
            _jobtitle = "title" + ":" + jobtitlefilter + ","
        }
      
        _filterData = _jobRefNo + _status + _jobtitle + _postingDate + _EndDate
        // // console.log("_filterData")
        // // console.log(_filterData)
        return _filterData
    }

    const handleClickSearch = () => {
        let _fdata = helperBuildCriteria()
        let _filterData = _fdata.split(",")
        let _objfd = {}

        let jsonData = {};
        for (let i = 0; i < _filterData.length - 1; i++) { 
            let columnName = _filterData[i].split(":")[0]
            _objfd[columnName] = _filterData[i].split(":")[1];
        }
        GetFilterResult(_objfd);
    }

    const GetFilterResult = async(_objfd) => {

        let filter_data = {}
        let dataTmp = []

        const Params = {
          "_collection" : "JobPosting",
          "filter_data" : _objfd
        }
        // // // console.log("Params GetFilterResult")
        // // // console.log(Params)
        axios
        .post(AppConfiguration.Setting().jobspaceapi + "action/get", Params)
        .then(res => {
            let data = res.data
            let itmList = [] 
            let newstr2=""
            data.JobPosting.map(function(itm,i){
                //// // // console.log("itm")
                //// // // console.log(itm)
                let strJson = "{" + itm.substring(46, itm.length)
                let strJson2 = itm.substring(18, itm.length)
                newstr2 = strJson2.split("')")[0]
                let json = JSON.parse(strJson.replace(/'/g,'"'));
                json.headerId = newstr2
                dataTmp.push(json)
            })    
            // console.log("dataTmp JobPosting" )
            // console.log(dataTmp)

            setDlistOfJobs(dataTmp) 
            let dataArry = dataTmp.filter((thing, index, self) =>
                index === self.findIndex((t) => (
                t.postingId === thing.postingId
            ))) 
            // // console.log("dataArry" )
            // // console.log(dataArry)
            dataArry.forEach((itm, idx)=>{
                // console.log("itm" )
                // console.log(itm)
                let applicants = applicantLists.filter( x => x.title === itm.title && x.postingId === itm.postingId)
                itmList.push({
                    Urgency : itm.Urgency,
                    active : itm.active,
                    aplicantExp : itm.aplicantExp,
                    applicantType : itm.applicantType,
                    companyId : itm.companyId,
                    companyProfile : itm.companyProfile,
                    createdBy : itm.createdBy,
                    createdDate : itm.createdDate,
                    dept : itm.dept,
                    description : itm.description,
                    education : itm.education,
                    educationalLevel : itm.educationalLevel,
                    endDate : itm.endDate,
                    experienceMax : itm.experienceMax,
                    experienceMin : itm.experienceMin,
                    id : itm.id,
                    isClosed : itm.isClosed,
                    isDeleted : itm.isDeleted,
                    isPosted : itm.isPosted,
                    jobDepartment : itm.jobDepartment,
                    jobPostingNote : itm.jobPostingNote,
                    jobTime : itm.jobTime,
                    keyWords : itm.keyWords,
                    level : itm.level,
                    postingId : itm.postingId,
                    qualifications : itm.qualifications,
                    responsibility : itm.responsibility,
                    salaryBasis : itm.salaryBasis,
                    salaryCurrency : itm.salaryCurrency,
                    salaryMax : itm.salaryMax,
                    salaryMin : itm.salaryMin,
                    skillsExperience : itm.skillsExperience,
                    startDate : itm.startDate,
                    timeStamp : itm.timeStamp,
                    title : itm.title,
                    type : itm.type,
                    updatedBy : itm.updatedBy,
                    updatedDate : itm.updatedDate,
                    workLocation : itm.workLocation,
                    workType : itm.workType,
                    workingDays : itm.workingDays,
                    workingDaysAndHrs : itm.workingDaysAndHrs,
                    workingHours : itm.workingHours,
                    industry : itm.industry,
                    applicants : String(applicants.length),
                })
                // console.log("itmList" )
                // console.log(itmList)
            })
            // // console.log("itmList" )
            // // console.log(itmList)
            setmainGrid([...itmList.sort((a, b) => a.id < b.id ? 1 : -1)]) 
            // const isValidate = JSON.parse(sessionStorage.getItem("userCollection"))
            // setmainGrid(dataArry.filter(List => isValidate.some(itm => itm.userid === List.companyId)))   
        })
        .catch(error =>{
            alert("error: " + error)
        })
    }
    const GetApplicants = async() =>{

        const _dataTmp = []
        const Params = {
            
            "_collection" : "Candidates",
            "filter_data" : {}
        }
        console.log("GetApplicants Params")
        console.log(Params)

        axios
        .post(AppConfiguration.Setting().jobspaceapi + "action/get", Params)
        .then(res => {
            let data = res.data
            console.log(" GetApplicantsdata")
            console.log(data)
            
                
            data.Candidates.map(function(itm,i){
                const strJson = itm.replace("","").replace("ObjectId(","").replace(")","").replace("_","")
                const json = /* strJson.replace(/'/g,'"') */ JSON.parse(strJson.replace(/'/g,'"'));
                _dataTmp.push(json)
            })
           
            
            console.log("GetApplicants _dataTmp")
            console.log(_dataTmp)
            setApplicantList(_dataTmp); 
            GetJobPosted(_dataTmp)

        }).catch(error =>{

            alert( "GetApplicants error: " + error)
        })
    }

    const GetCandidatesFilterd = async(toEdit) => {

        let filter_data = {postingId:toEdit.postingId }
        let dataTmp = []

        const Params = {
          "_collection" : "Candidates",
          "filter_data" : filter_data
        }
        //// // // console.log("Params GetCandidatesFilterd")
        //// // // console.log(Params)
        axios
        .post(AppConfiguration.Setting().jobspaceapi + "action/get", Params)
        .then(res => {

            let data = res.data
            //// // // console.log("data")
            //// // // console.log(data)
            let newstr2=""
            data.Candidates.map(function(itm,i){
                //// // // console.log("itm")
                //// // // console.log(itm)
                let strJson = "{" + itm.substring(46, itm.length)
                let strJson2 = itm.substring(18, itm.length)
                newstr2 = strJson2.split("')")[0]
                let json = JSON.parse(strJson.replace(/'/g,'"'));
                json.headerId = newstr2
                dataTmp.push(json)
            })    
            //// // // console.log("dataTmp GetCandidates" )
            //// // // console.log(dataTmp)

            setDlistOfJobs(dataTmp)   
            setmainGrid(dataTmp) 
        })
        .catch(error =>{
            alert("error: " + error)
        })
    }

    const GetCandidates = async() => {

        let filter_data = {"isDeleted": "0", }
        let dataTmp = []

        const Params = {
          "_collection" : "Candidates",
          "filter_data" : filter_data
        }
        axios
        .post(AppConfiguration.Setting().jobspaceapi + "action/get", Params)
        .then(res => {

            let data = res.data
            //// // // console.log("data")
            //// // // console.log(data)
            let newstr2=""
            data.Candidates.map(function(itm,i){
                //// // // console.log("itm")
                //// // // console.log(itm)
                let strJson = "{" + itm.substring(46, itm.length)
                let strJson2 = itm.substring(18, itm.length)
                newstr2 = strJson2.split("')")[0]
                let json = JSON.parse(strJson.replace(/'/g,'"'));
                json.headerId = newstr2
                dataTmp.push(json)
            })    
            //// // // console.log("dataTmp GetCandidates" )
            //// // // console.log(dataTmp)

            setDlistOfJobs(dataTmp)   
            setmainGrid(dataTmp) 
        })
        .catch(error =>{
            alert("error: " + error)
        })
    }

    const GetCompanyProfile = async() => {
        let filter_data = {"isDeleted": "0", }
        let dataTmp = []
        const Params = {
          "_collection" : "CompanyProfile",
          "filter_data" : filter_data
        }
        axios
        .post(AppConfiguration.Setting().jobspaceapi + "action/get", Params)
        .then(res => {

            let data = res.data
            let newstr2=""
            data.CompanyProfile.map(function(itm,i){
                let strJson = "{" + itm.substring(46, itm.length)
                let strJson2 = itm.substring(18, itm.length)
                newstr2 = strJson2.split("')")[0]
                let json = JSON.parse(strJson.replace(/'/g,'"'));
                json.headerId = newstr2
                dataTmp.push(json)
            })    

            //console.log("dataTmp GetCompanyProfile")
            //console.log(dataTmp)
            setcompanyProfiles(dataTmp)   
            sessionStorage.setItem("CompanyProfile" , JSON.stringify(dataTmp))
        })
        .catch(error =>{
            alert(" GetCompanyProfileerror: " + error)
        })
    };

    const GetJobPosted = async(itmList) => {
        const isValidate = JSON.parse(sessionStorage.getItem("userCollection"))
        // console.log("isValidate")
        // console.log(isValidate)
        let _dataLst = []
        try{
          let resp = await GetRequest({
            url : AppConfiguration.Setting().jobspaceapi + "action/get",
            params : {
              "dbname"      :  AppConfiguration.Setting().noserJobSpaceDB_Prod,
              "_collection" : "JobPosting",
              "filter_data" : {}
            }
          })
          // console.log("itmList")
          // console.log(itmList)
          if(resp.status==="1"){
            // let arr = resp.JobPosting.filter(f => applicantLists.some(item => item.postingId === f.postingId))
            resp.JobPosting.map(function(itm,i){
                let applicants = itmList.filter( x => x.title === itm.title && x.postingId === itm.postingId)
                console.log("applicants.length")
                console.log(applicants.length)
                _dataLst.push({
                    Urgency : itm.Urgency,
                    active : itm.active,
                    aplicantExp : itm.aplicantExp,
                    applicantType : itm.applicantType,
                    companyId : itm.companyId,
                    companyProfile : itm.companyProfile,
                    createdBy : itm.createdBy,
                    createdDate : itm.createdDate,
                    dept : itm.dept,
                    description : itm.description,
                    education : itm.education,
                    educationalLevel : itm.educationalLevel,
                    endDate : itm.endDate,
                    experienceMax : itm.experienceMax,
                    experienceMin : itm.experienceMin,
                    id : itm.id,
                    isClosed : itm.isClosed,
                    isDeleted : itm.isDeleted,
                    isPosted : itm.isPosted,
                    jobDepartment : itm.jobDepartment,
                    jobPostingNote : itm.jobPostingNote,
                    jobTime : itm.jobTime,
                    keyWords : itm.keyWords,
                    level : itm.level,
                    postingId : itm.postingId,
                    qualifications : itm.qualifications,
                    responsibility : itm.responsibility,
                    salaryBasis : itm.salaryBasis,
                    salaryCurrency : itm.salaryCurrency,
                    salaryMax : itm.salaryMax,
                    salaryMin : itm.salaryMin,
                    skillsExperience : itm.skillsExperience,
                    startDate : itm.startDate,
                    timeStamp : itm.timeStamp,
                    title : itm.title,
                    type : itm.type,
                    updatedBy : itm.updatedBy,
                    updatedDate : itm.updatedDate,
                    workLocation : itm.workLocation,
                    workType : itm.workType,
                    workingDays : itm.workingDays,
                    workingDaysAndHrs : itm.workingDaysAndHrs,
                    workingHours : itm.workingHours,
                    industry : itm.industry,
                    applicants : String(applicants.length),
                })
                // console.log(_dataLst[0].companyId)
                // console.log(isValidate[0].userId)
            })  
            setmainGrid(_dataLst) 
            // setmainGrid(_dataLst.filter(List => isValidate.some(itm => itm.userid === List.companyId)))   
          }
        }
        catch(error){
          // setMessage(error.message)
          // console.log("error: " + error.message)
        }
    };

    const handleViewJobPost=(row)=>{
        // // console.log("handleView")
        // // console.log(row)
        sessionStorage.setItem("jobPostedEdit", JSON.stringify(row))
        window.location.href='/CreateJobPosting'
      
    }

 
  
    /* Get items */
    async function OnLoadScreen(){
        // setJobType("")
        // setCategory("")
        // setJobOverviewLocation("")
        // setOfferedSalary("")
        // setPosted("")
        // setExperience("")
        // setGender("0")
        // setIndustry("")
        // setQualification("")
        // setLevel("")
        // setApplied("")
    }

    const rowEvents = {
      /*   onClick: (e, row, rowIndex) => {
            //// // // console.log("onClick")
            //// // // console.log(rowIndex)
            //handleView(row)
           
        }, */
     
    };

    const handleViewResume=(row)=>{
        //// // // console.log("handleViewResume")
        //// // // console.log(row)
        sessionStorage.setItem("ListOfCandidate", JSON.stringify(row))
        window.location.href='/ListOfCandidate'
      
    }

    const handleDownloadResume=(row)=>{
        //// // // console.log("handleDownloadResume")
        //// // // console.log(row)
        //sessionStorage.setItem("jobPostedEdit", JSON.stringify(row))
       // window.location.href='/CreateJobPosting'
      
    }

    const handleSchedInterview=(row)=>{
        //// // // console.log("handleSchedInterview")
        //// // // console.log(row)
        //sessionStorage.setItem("jobPostedEdit", JSON.stringify(row))
       // window.location.href='/CreateJobPosting'
      
    }

    const onChangeSearch=(e)=>{
        //// // // console.log("handleSearch")
        //// // // console.log(e.target.value)
        setsearch(e.target.value)
        //// // // console.log(listOfJobs)
        if(e.target.value === ""){
            //// // // console.log("search === blank")
            setmainGrid(listOfJobs)
        }
        //sessionStorage.setItem("jobPostedEdit", JSON.stringify(row))
       // window.location.href='/CreateJobPosting'
      
    }

    const GridDataModified=(oldValue, newValue, id, column , index)=>{
        mainGrid.map(function(item,i,index) {
            if (item.id === id){
                item.isModified = newValue!=oldValue ? "1" : "0"
               /*  // // // console.log("GridDataModified item")
                // // // console.log(item.isModified)
                // // // console.log(item.headerId) */
                if(item.isModified == "1"){
                    saveGrid(item)
                 
                }
               
                
                
            }
        })
    }

    const saveGrid=(item)=>{

        const updateParams = {
    
            "_collection" : "Candidates",
            "doc_data"    : item,
            "_id"         : item.headerId,
      
        }

    
        // // // console.log("saveGrid updateParams")
        // // // console.log(updateParams)
      
        axios
        .post(AppConfiguration.Setting().jobspaceapi + "action/update_one", updateParams)
        .then(res => {
            let data = res.data
            
            // // // console.log("update_one data")
            // // // console.log(data)
            // // // console.log("update_one data end")
          
        
        }).catch(error =>{
            
            // // // console.log("error: " + error)
          
    
        })
    }

    const onChangejobRef = (e) => {
        setjobRef(e.target.value)
    }
    const onChangepstingDateFilter = (e) => {
        setpstingDateFilter(e.target.value)
    }
    const onChangejobPostStatus = (e) => {
        setjobPostStatus(e.target.value)
    }
    const onChangejobtitlefilter = (e) => {
        setjobtitlefilter(e.target.value)
    }
    const onChangeendDateFilter = (e) => {
        setendDateFilter(e.target.value)
    }
    function handleClickColumn (key){
        // // // // console.log("key")
        // // // // console.log(key)
        sessionStorage.setItem("key", JSON.stringify(key))
        // navigateJobDetails("/JobDescEmployer")
    }
    function handleNavigateApplicants (key){
        // // // // console.log("key")
        // // // // console.log(key)
        sessionStorage.setItem("JobPostingList", JSON.stringify(key))
        sessionStorage.setItem("validate", JSON.stringify(1))
        // navigateJobDetails("/JobDescEmployer")
    }
    
    const sizePerPageRenderer = ({
        options,
        currSizePerPage,
        onSizePerPageChange
        }) => (
        <div className="btn-group" role="group">
            {
                options.map((option) => {
                    const isSelect = currSizePerPage === `${option.page}`;
                    return (
                    <button
                        key={ option.text }
                        type="button"
                        onClick={ () => onSizePerPageChange(option.page) }
                        className={ `btn ${isSelect ? 'btn-primary' : '#F0FEED'}` }
                    >
                        { option.text }
                    </button>
                    );
                })
            }
        </div>
    );
    const handleRepostJob = async(row) =>{
        // // console.log("row")
        // // console.log(row.postingId)
        setModalValidationNotif(true)
        let _dataLst = []
        try{
          let resp = await GetRequest({
            url : AppConfiguration.Setting().jobspaceapi + "action/get",
            params : {
              "dbname"      :  AppConfiguration.Setting().noserJobSpaceDB_Prod,
              "_collection" : "JobPosting",
              "filter_data" : {}
            }
          })
        //   // console.log("resp")
        //   // console.log(resp)
            if(resp.status==="1"){
                // let arr = resp.JobPosting.filter(f => applicantLists.some(item => item.postingId === f.postingId))
                resp.JobPosting.map(function(itm,i){
                    // let applicants = itmList.filter( x => x.title === itm.title)
                    //  // console.log("applicants.length")
                    //  // console.log(applicants.length)
                    _dataLst.push({
                        Urgency : itm.Urgency,
                        active : itm.active,
                        aplicantExp : itm.aplicantExp,
                        applicantType : itm.applicantType,
                        companyId : itm.companyId,
                        companyProfile : itm.companyProfile,
                        createdBy : itm.createdBy,
                        createdDate : itm.createdDate,
                        dept : itm.dept,
                        description : itm.description,
                        education : itm.education,
                        educationalLevel : itm.educationalLevel,
                        endDate : itm.endDate,
                        experienceMax : itm.experienceMax,
                        experienceMin : itm.experienceMin,
                        id : itm.id,
                        isClosed : itm.isClosed,
                        isDeleted : itm.isDeleted,
                        isPosted : itm.isPosted,
                        jobDepartment : itm.jobDepartment,
                        jobPostingNote : itm.jobPostingNote,
                        jobTime : itm.jobTime,
                        keyWords : itm.keyWords,
                        level : itm.level,
                        postingId : itm.postingId,
                        qualifications : itm.qualifications,
                        responsibility : itm.responsibility,
                        salaryBasis : itm.salaryBasis,
                        salaryCurrency : itm.salaryCurrency,
                        salaryMax : itm.salaryMax,
                        salaryMin : itm.salaryMin,
                        skillsExperience : itm.skillsExperience,
                        startDate : itm.startDate,
                        timeStamp : itm.timeStamp,
                        title : itm.title,
                        type : itm.type,
                        updatedBy : itm.updatedBy,
                        updatedDate : itm.updatedDate,
                        workLocation : itm.workLocation,
                        workType : itm.workType,
                        workingDays : itm.workingDays,
                        workingDaysAndHrs : itm.workingDaysAndHrs,
                        workingHours : itm.workingHours,
                        industry : itm.industry,
                        // applicants : String(applicants.length),
                    })
                })   
            }
            // console.log("_dataLst")
            // console.log(_dataLst.filter(x=>x.postingId === row.postingId))

            var nf = new Intl.NumberFormat();
            let newdatetmp = new Date()
            let futureDate =  moment(new Date(newdatetmp)).format('MM/DD/YYYY');
            let applicationDate = dateFormat(futureDate).split(" ")
            let getMM = futureDate.split("/")[0]
            let getYear = applicationDate[3]
            let getYear2 = getYear[2]+getYear[3]
            let JobPostId = parseFloat(_dataLst.length) + 1
            let newpostingIdtmp2 = "PH"+"-"+"JS"+"-"+getYear2+"-"+getMM+"-"+JobPostId
            let dataFilter = _dataLst.filter(x=>x.postingId === row.postingId)

            let toSave = {
            
            "postingId"       : String(newpostingIdtmp2),
            "title"           : toTitleCase(dataFilter[0].title),
            "companyId"       : dataFilter[0].companyId,
            "startDate"       : dataFilter[0].startDate,
            "endDate"         : dataFilter[0].endDate,
            "Urgency"         : dataFilter[0].Urgency,
            "description"     : dataFilter[0].description,
            "type"            : dataFilter[0].type,
            "salaryMin"       : dataFilter[0].salaryMin,
            "salaryMax"       : dataFilter[0].salaryMax,
            "salaryCurrency"  : dataFilter[0].salaryCurrency,
            "salaryBasis"     : dataFilter[0].salaryBasis,
            "level"           : dataFilter[0].level,
            "experienceMin"   : dataFilter[0].experienceMin,
            "experienceMax"   : dataFilter[0].experienceMax,
            "keyWords"        : toTitleCase(dataFilter[0].keyWords),
            "responsibility"  : dataFilter[0].responsibility,
            "qualifications"  : dataFilter[0].qualifications,
            "workingHours"    : dataFilter[0].workingHours,
            "workLocation"    : toTitleCase(dataFilter[0].workLocation),
            "jobDepartment"   : dataFilter[0].jobDepartment,
            "jobTime"         : dataFilter[0].jobTime,
            "educationalLevel": dataFilter[0].educationalLevel,
            "applicantType"   : dataFilter[0].applicantType,
            "skillsExperience": dataFilter[0].skillsExperience,
            "companyProfile"  : dataFilter[0].companyProfile,
            "isDeleted"       : "0",
            "isPosted"        : "0",
            "isClosed"        : "0",
            "createdBy"       : dataFilter[0].createdBy,
            "createdDate"     : dataFilter[0].createdDate,
            "updatedBy"       : dataFilter[0].updatedBy,
            "updatedDate"     : dataFilter[0].updatedDate,
            "timeStamp"       : "2024041012345",
            "dept"            : toTitleCase(dataFilter[0].dept),
            "workType"        : dataFilter[0].workType,
            "education"       : dataFilter[0].education,
            "aplicantExp"     : dataFilter[0].aplicantExp,
            "jobPostingNote"  : toTitleCase(dataFilter[0].jobPostingNote),
            "workingDays"     : toTitleCase(dataFilter[0].workingDays),
            "workingDaysAndHrs"  : toTitleCase(dataFilter[0].workingDaysAndHrs),
            "active"          : "1",
            "industry"          : toTitleCase(dataFilter[0].industry),
            }
            // // console.log("toSave")
            // // console.log(toSave)
            const saveParams = {
                "_collection" : "JobPosting",
                "doc_data"    : toSave,
            }
            // console.log("onClickPostAJob toSave")
            // console.log(saveParams)
            axios
            .post(AppConfiguration.Setting().jobspaceapi + "action/add", saveParams)
            .then(res => {
            let data = res.data
            // setalerttype("Success!")
            // setisshow(true)
            // setcolor("success")
            // setmessage(data)
            // setfade(true)
            // setdisableSave(true)
            let newbox = []
            newbox.push(toSave) 
            sessionStorage.setItem("key", JSON.stringify(row.postingId))
            
            }).catch(error =>{
                // setalerttype("Error!")
                // setisshow(true)
                // setcolor("danger")
                // setmessage("error: " + error)
                // setfade(true)
                // setdisableSave(true)
                sessionStorage.removeItem("jobPostedEdit")
            })
        }
        catch(error){
          // setMessage(error.message)
          // console.log("error: " + error.message)
        }
    }

    const ModalCancel = async () =>{
        setModalValidationNotif(false)
    }
    const modalView = async() =>{
        window.location.href='/JobDescEmployer' 
    }
    
    /* Proper Case */
    function toTitleCase(str) {
        const titleCase = str
        .toLowerCase()
        .split(' ')
        .map(word => {
            return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(' ');
    
        return titleCase;
    }
    const columns = [
        {
            dataField   : 'postingId',
            text        : 'Job Post Reference',
            editable:false,
            headerStyle : () => {
                return { width  : "20%",  fontWeight : "bold" };
            },
            style:{/*  */ whiteSpace: 'nowrap'},
            formatter   :   (cell, row, isSelect) => {
                return (
                    <div style={{}}>
                        <Link style={{height:'20px',paddingTop:'0',marginTop:'-4px', fontSize:'14px', color : "#0A6219"}} 
                            variant="link" to="/JobDescEmployer" onClick={() =>handleClickColumn(row.postingId)}
                        >
                            <b><u>{row.postingId}</u></b>
                        </Link>
                    </div>
                )
            },
        },
        {
            dataField   : 'title',
            text        : 'Job Title',
            editable:false,
            headerStyle : () => {
                return { width  : "30%", fontWeight : "bold" };
            },
            style:{/*  */ whiteSpace: 'nowrap', },
            formatter   :   (cell, row, isSelect) => {
                return (
                    <Link style={{height:'20px',paddingTop:'0',marginTop:'-4px',fontSize:'14px', color : "#0A6219"}} 
                        variant="link" to="/JobDescEmployer" onClick={() =>handleClickColumn(row.postingId)}
                    ><b><u>{row.title}</u></b></Link>
                )
            },
        },
        {
            dataField   : 'startDate',
            text        : 'Posted Date',
            editable:false,
            headerStyle : () => {
                return { width  : "10%", fontWeight : "bold" };
            },
            style:{/*  */ whiteSpace: 'nowrap',fontSize:'14px', color: "#000000"}
        },
        {
            dataField   : 'endDate',
            text        : 'End Date',
            editable:false,
            headerStyle : () => {
                return { width  : "10%" , fontWeight : "bold"};
            },
            style:{/*  */ whiteSpace: 'nowrap',fontSize:'14px', color: "#000000"}
        },
        {
            dataField   : 'createdBy',
            text        : 'Posted By',
            editable:false,
            headerStyle : () => {
                return { width  : "10%", fontWeight : "bold" };
            },
            style:{/*  */ whiteSpace: 'nowrap', fontSize:'14px', color: "#000000"}
        },
        {

            dataField   : 'applicants',
            text        : 'Applicants',
            editable:false,
            headerStyle : () => {
                return { width  : "10%" , fontWeight : "bold"};
            },
            style:{/*  */ whiteSpace: 'nowrap',  },
            formatter   :   (cell, row, isSelect) => {
                return (
                    <Link style={{height:'20px',paddingTop:'0',marginTop:'-4px',fontSize:'14px', color : "#0A6219"}} 
                        variant="link" to="/ListOfCandidate" onClick={() =>handleNavigateApplicants(row)}
                        ><b>{row.applicants}</b>
                    </Link>
                )
            },
        },
        {
            dataField   : 'action',
            text        : 'Action',
            editable:false,
            headerStyle : () => {
                return { width  : "10%", fontWeight : "bold"};
            },
            style:{/*  */ whiteSpace: 'nowrap', color: "#000000"},
            formatter   :   (cell, row, isSelect) => {
                if(row)
                return (
                    <div>
                    <i className="mdi mdi-power" id="1" style={{padding: 6}}></i>
                    <i className="mdi mdi-refresh" id="2"style={{marginLeft:"10%", padding: 6}}></i>
                    <i className="mdi mdi-grease-pencil" id="3"style={{marginLeft:"10%", padding: 6}}></i>
                    </div>
                );
            },
            events: {
                onClick: (e, column, columnIndex, row, rowIndex) => {
                    // console.log(e.target.id);
                    if(e.target.id === "3"){
                        handleViewJobPost(row)
                    }
                    if(e.target.id === "2"){
                        handleRepostJob(row)
                        // alert("repost")
                    }
                },
            }
        },
        
       
    ]

    const selectRow = {
        //mode: 'checkbox',
        clickToSelectAndEditCell: false,
        hideSelectColumn: true,
        onSelect: (row, isSelect, rowIndex, e) => {
            let disable = true
            listOfJobs.map(function(item,i){
                if(item.id===row.id)
                {
                    ////// // // console.log(row)
                    item.isDeleted = isSelect ? "1" : "0"
                    item.isModified = isSelect ? "1" : "0"
                    disable = isSelect ? false : true
                }
            })
        }
    };

    function handleClickClear (){
        sessionStorage.removeItem("validate")
        sessionStorage.removeItem("JobPostingList")
        sessionStorage.removeItem("jobPostedEdit")
    }
    return (
        <React.Fragment>
            <Card className="job-detail overflow-hidden mt-1" >
                <CardBody className="p-4" style={{ marginTop : "3%", border: "1px solid blue"}}>
                    <Row>
                        <Col lg={1}></Col>
                        <Col lg={10}>
                            <Label style={{ color: "#0A6219", marginTop:"25px", fontSize: "20px"}}><b>Job Posting ( <Link  onClick={() => handleClickClear()} to="/CreateJobPosting"><i><u>Create</u></i></Link> )</b></Label>
                            <Card className="mt-1" style={{ borderColor: "green"}}>
                                
                                <Row className="mt-4" >
                                    <Col lg={1}>
                                    </Col>
                                    <Col lg={2}>
                                        <Label  style={{ marginTop:"10px", marginLeft:'29px', color:"#0A6219", fontSize: "14px", fontWeight: "bold"}}>Job Post Reference : </Label>
                                    </Col>
                                    <Col lg={2}>
                                        <Input
                                            type="text"
                                            className="form-control"
                                            id="nameControlInput"
                                            // placeholder="Enter Job Post Reference"
                                            style={{ borderStyle: "outset",marginLeft:"-55px"/* marginBottom:"5px",background:"#F0FEED" */}}
                                            value={jobRef}
                                            onChange={onChangejobRef}
                                                
                                        />
                                    </Col>
                                    <Col lg={2}>
                                        <Label  style={{ marginTop:"10px", marginLeft:'29px',color:"#0A6219" , fontSize: "14px", fontWeight: "bold"}}>Posted Date : </Label>
                                    </Col>
                                    <Col lg={2}>
                                        <Input
                                            type="date"
                                            className="form-control"
                                            id="nameControlInput"
                                            //placeholder="Max Salary Offer"
                                            style={{ borderStyle: "outset",marginLeft:"-85px"/* marginBottom:"5px",background:"#F0FEED" */}}
                                            value={pstingDateFilter}
                                            onChange={onChangepstingDateFilter}
                                                
                                        />
                                    </Col>
                                    {/* <Col lg={2}>
                                        <Label  style={{ marginTop:"10px", marginLeft:'29px',color:"#0A6219" , fontSize: "14px"}}>Job Post Status : </Label>
                                    </Col>
                                    <Col lg={2}>
                                        <Input
                                            type="text"
                                            className="form-control"
                                            id="nameControlInput"
                                            //placeholder="Max Salary Offer"
                                            style={{ borderStyle: "outset",marginLeft:"-85px"}}
                                            value={jobPostStatus}
                                            onChange={onChangejobPostStatus}
                                                
                                        />
                                    </Col> */}
                                    
                                </Row>
                                <Row className="mt-3"  style={{  marginBottom:"20px",}}>
                                    <Col lg={1}>
                                    </Col>
                                    <Col lg={2}>
                                        <Label  style={{ marginTop:"10px", marginLeft:'29px', color:"#0A6219" , fontSize: "14px", fontWeight: "bold"}}>Job Title : </Label>
                                    </Col>
                                    <Col lg={2}>
                                        {/* <Input
                                            type="text"
                                            className="form-control"
                                            id="nameControlInput"
                                            //placeholder="Max Salary Offer"
                                            style={{ borderStyle: "outset",marginLeft:"-55px"}}
                                            value={jobtitlefilter}
                                            onChange={onChangejobtitlefilter}
                                                
                                        /> */}
                                        <select
                                            name="jobtitlefilter"
                                            className="form-control"
                                            style={{ borderStyle: "outset",marginLeft:"-55px"}}
                                            // value={row.itemCode}
                                            // disabled = {row.taxType === "" ? true : false}
                                            onChange={(e) => onChangejobtitlefilter(e, e.target.value)} 
                                            >
                                            <option> </option>
                                                {mainGrid.sort((a, b) => a.id < b.id ? 1 : -1).filter(x=> x.title !== "").map((itm, idx) => (
                                                <option key={idx} value={itm.title}>{itm.title}</option>
                                                ))
                                            }
                                        </select>
                                    </Col>
                                    <Col lg={2}>
                                        <Label  style={{ marginTop:"10px", marginLeft:'29px',color:"#0A6219" , fontSize: "14px", fontWeight: "bold"}}>End Date : </Label>
                                    </Col>
                                    <Col lg={2}>
                                        <Input
                                            type="date"
                                            className="form-control"
                                            id="nameControlInput"
                                            //placeholder="Max Salary Offer"
                                            style={{ borderStyle: "outset",marginLeft:"-85px"/* marginBottom:"5px",background:"#F0FEED" */}}
                                            value={endDateFilter}
                                            onChange={onChangeendDateFilter}
                                        />
                                    </Col>
                                    <Col lg={2}>
                                        <button type="submit" className="btn-success noser-button-md" onClick={handleClickSearch} style={{minWidth : "10%", textAlign: "center", marginRight : "2%", backgroundColor: "green", border: "2px solid green", fontWeight: "bold", color : "white"}}>
                                            Search
                                        </button>
                                        <button type="submit" className="noser-button-md" onClick={() => window.location.reload(true)} style={{minWidth : "10%", textAlign: "center", backgroundColor: "transparent", border: "1px solid green", fontWeight: "bold", color : "green"}}>
                                            Clear
                                        </button>
                                    </Col>
                                </Row>
                                {/* <Row className="mt-3 "  style={{  marginBottom:"5px",marginLeft:"80%"}}>
                                    <Col  lg={12}>
                                        <button type="submit" className="btn" onClick={handleChangeSearch} style={{minWidth : "10%", textAlign: "center", marginRight : "2%", backgroundColor: "transparent", border: "2px solid green", fontWeight: "bold", color : "green"}}>
                                            Search
                                        </button>
                                        <button type="submit" className="btn"  style={{minWidth : "10%", textAlign: "center", backgroundColor: "transparent", border: "1px solid green", fontWeight: "bold", color : "green"}}>
                                            Clear
                                        </button>
                                    </Col>
                                </Row> */}
                            </Card>
                        </Col>
                        <Col lg={1}></Col>
                    </Row>
                    <Row className="mt-2">
                        <Col lg={1}></Col>
                        <Col lg={10}>
                            <Card className="mt-2" style={{ borderColor: "green", padding: 20}}>
                                <Row>   
                                    <Col lg={12}>                    
                                        <BootstrapTable
                                            keyField="headerId"
                                            data={ mainGrid.sort((a, b) => a.id < b.id ? 1 : -1) }
                                            columns={ columns }
                                            bordered={ true }
                                            rowEvents={ rowEvents }
                                            // rowClasses="rowmargin"
                                            // className="rowmargin"
                                            noDataIndication={ () => <div>No record found.</div> }
                                            cellEdit = { cellEditFactory({
                                                mode: 'dbclick',
                                                blurToSave: true,
                                                afterSaveCell: (oldValue, newValue, row, column) => {
                                                    GridDataModified(oldValue, newValue, row.id, column.dataField , row)
                                                    }
                                                })
                                            }
                                            // pagination={ paginationFactory({sizePerPageRenderer}) }
                                            selectRow = { selectRow }
                                            // striped
                                            hover
                                            condensed
                                        />
                                    </Col> 
                                </Row>
                            </Card>
                        </Col>
                        <Col lg={1}></Col>
                    </Row>
                </CardBody>
            </Card>
            <div
                className="modal fade"
                id="modalNotif"
                tabIndex="-1"
                aria-labelledby="modalNotif"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered">
                <Modal isOpen={modalNotif} toggle={openModalNotif} centered>
                    <ModalBody className="p-5" style={{/* backgroundColor: "#fcffb9" */}}>
                        <Card>
                            <CardBody style={{border: "1px solid green"}}>
                                <Row>
                                    <Col sm={12}>
                                        <p style={{ alignItems: "center", fontSize: "16px", fontWeight: "bolder", color : "#000000"/* , marginLeft: "2%" */}}>Job Position was already Reposted.</p>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        <button type="submit" className="btn-success noser-button-md" onClick={modalView} style={{minWidth : "10%", textAlign: "center", marginRight : "2%", backgroundColor: "green", border: "2px solid green", fontWeight: "bold", color : "white"}}>
                                            View
                                        </button>
                                        <button type="submit" className="noser-button-md" onClick={ModalCancel} style={{minWidth : "10%", textAlign: "center", marginRight : "2%", backgroundColor: "transparent", border: "1px solid green", fontWeight: "bold", color : "green"}}>
                                            Cancel
                                        </button>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </ModalBody>
                </Modal>
                </div>
            </div>
        </React.Fragment>
    );
};

export default EmployerJobPostingList;